/* eslint-disable etc/no-commented-out-code */
import { logger as LOG } from '@sweetgreen/garnish';

const name = 'TELEMETRY';
const eventName = 'TELEMETRY_EVENT';
const mockName = 'TELEMETRY_MOCK';

export const logger = LOG.extend(name);
export const eventLogger = LOG.extend(eventName);
export const mockLogger = LOG.extend(mockName);

// LOG.enable(name);
// LOG.enable(eventName);
// LOG.enable(mockName);
